// extracted by mini-css-extract-plugin
export var offBottom = "VideoTestimonialCarousel-module--off-bottom--b6983";
export var offTop = "VideoTestimonialCarousel-module--off-top--7dabb";
export var overlay = "VideoTestimonialCarousel-module--overlay--d3300";
export var scrollable = "VideoTestimonialCarousel-module--scrollable--e00e2";
export var scrollbox = "VideoTestimonialCarousel-module--scrollbox--56afa";
export var shadow = "VideoTestimonialCarousel-module--shadow--f1c33";
export var shadowBottom = "VideoTestimonialCarousel-module--shadow-bottom--ba166";
export var shadowTop = "VideoTestimonialCarousel-module--shadow-top--49149";